<template>
  <pt-work-order-table class="pt-work-order-table__withData"  @getOrderWorkList="getOrderWorkList" :tableLabels="tableLabels" :page-size="page_size"
  :tableData="tableData" :totalNumber="totalNumber" ref="table" :loading="loading" :isOutside="isOutside">
    <slot/>
  </pt-work-order-table>
</template>

<script>
import PtWorkOrderTable from './index'
export default {
  name: 'pt-work-order-table__withData',
  props: {
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 10
    },
    paramsData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isSearch: {
      type: String
    },
    isFromRouter: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'pt-work-order-table': PtWorkOrderTable
  },
  data () {
    return {
      totalNumber: 0,
      page_size: this.pageSize,
      tableData: [],
      page: 0,
      sign: 0,
      isOutside: false,
      loading: false
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        if (!this.isFromRouter) {
          this.sign = 0
          // this.getOrderWorkList(0)
          this.$refs.table.resetPage()
        } else {
          this.isOutside = true
          this.getOrderWorkList(this.page)
        }
      }
    }
    // isSearch (val) {
    //   this.sign = 1
    //   this.getOrderWorkList(0)
    //   // this.getOrderWorkSearch(0)
    // }
  },
  methods: {
    // getOrderWorkSearch (page, next) {

    // },
    getOrderWorkList (page, next) {
      // if (this.sign === 0) {
      this.page = page
      let data = {
        ...this.paramsData,
        pageableParam: {
          page: page,
          size: this.page_size
        }
      }
      if (!next) {
        this.loading = true
      }
      this.$store.dispatch('getOrderWorkList', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
        this.loading = false
      }).catch(err => {
        this.$message.error(err || '获取预约类咨询工单失败')
        this.loading = false
      })
      // } else if (this.sign === 1) {
      //   let name
      //   if (this.isSearch) {
      //     name = this.isSearch
      //   } else {
      //     name = undefined
      //   }
      //   this.page = page
      //   let data = {
      //     name: name,
      //     page: page,
      //     size: this.page_size
      //   }
      //   this.$store.dispatch('getOrderWorkSearch', data).then(res => {
      //     this.tableData = res.data
      //     this.totalNumber = res.totalNumber
      //     if (next) {
      //       next(res.data)
      //     }
      //   }).catch(err => {
      //     this.$message.error(err || '获取意见反馈列表失败')
      //   })
      // }
    },
    toEduce () {
      this.$refs.table.toEduce()
    }
  }
}
</script>
